import { React, useEffect, useState } from "react";
import styles from "./languagePalsPage.module.css";
import Pal from "../../../components/pal/Pal";
import axios from "axios";
import SearchComp from "../../../components/search/SearchComp";
import LearningZonesComp from "../../../components/learningZonesComp/LearningZonesComp";
import { v4 as uuid } from "uuid";
import { useParams } from "react-router-dom";

const apiUrl = process.env.REACT_APP_URL;

const LanguagePalsPage = ({ isOwnProfile }) => {
  /* Language Pals Page contains a list of the user's Pals (friends), including usernames and profile images. The user can contact a Pal via this page, and he can also remove a Pal. In addition, the user can filter the list by a search query, and also access the Pals profile pages. This component is also used to display the Pals list of a user to a Pal of the user. In this case, the only possible functionalities are visiting the profile page and messaging a user. */

  const [username, setUsername] = useState("");
  const [offset, setOffset] = useState(0);
  const [palsList, setPalsList] = useState([]);
  const [hasMorePals, setHasMorePals] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const qty = 12;

  let { username: activeUsername } = useParams();

  useEffect(() => {
    const getUserPals = async () => {
      try {
        let res;

        /* Get the active username */
        if (!isOwnProfile && activeUsername) {
          setUsername(activeUsername);
        } else if (isOwnProfile) {
          res = await axios.get(`${apiUrl}/auth/user`, {
            withCredentials: true,
          });

          if (res.status === 200 && res.data.success) {
            setUsername(res.data.username);
          }
        }

        // Check if username is set before making the request
        if (!username) {
          return;
        }

        const palsRes = await axios.get(
          `${apiUrl}/relationships/pals/${username}`,
          {
            withCredentials: true,
            params: {
              qty: qty,
              offset: offset,
              searchTerm: searchTerm,
            },
          }
        );

        if (palsRes.status === 200) {
          setHasMorePals(palsRes.data.length >= qty);

          setPalsList((prevPals) => {
            // If searchTerm has changed, replace the pals list instead of appending
            return offset === 0 ? palsRes.data : [...prevPals, ...palsRes.data];
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error("User is not logged in");
        } else {
          console.error("Error checking login status", error);
        }
      }
    };

    getUserPals();
  }, [activeUsername, isOwnProfile, username, offset, searchTerm]);

  const loadMorePals = () => {
    setOffset((prevOffset) => prevOffset + qty);
  };

  const handleSearchTermChange = async (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes
  };

  const removePalFromList = (palUsername) => {
    setPalsList((prevPals) =>
      prevPals.filter((pal) => pal.friend !== palUsername)
    );
  };

  const pals = palsList.map((pal) => (
    <Pal
      currUsername={username}
      isOwnProfile={isOwnProfile}
      username={pal.friend}
      imgUrl={pal.img_link}
      removePalFromList={removePalFromList}
      key={uuid()}
    />
  ));

  return (
    <div className={styles.main}>
      {/* main layout  */}
      <section className={styles.mainLayout}>
        {/* left section  */}
        <div className={styles.left}>
          <LearningZonesComp />
        </div>
        {/* middle section  */}
        <div className={styles.middle}>
          <section className={styles.pals}>
            <h1>
              Language Pals{" "}
              {!isOwnProfile && username && <span>- {username} </span>}
            </h1>
            <div className={styles.searchArea}>
              <label>Search</label>
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchTermChange}
              />
            </div>
            <div className={styles.palsList}>{pals}</div>
            {hasMorePals && (
              <button onClick={loadMorePals} className={styles.viewMoreButton}>
                View More
              </button>
            )}
          </section>
        </div>
        {/* right section  */}
        <div className={styles.right}>
          <SearchComp />
        </div>
      </section>
    </div>
  );
};

export default LanguagePalsPage;
